import { render, staticRenderFns } from "./general-requests.vue?vue&type=template&id=2c88f5ee&scoped=true&"
import script from "./general-requests.vue?vue&type=script&lang=js&"
export * from "./general-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c88f5ee",
  null
  
)

export default component.exports